import React, { useEffect , useState } from "react";
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Col, Row } from "reactstrap";
import axios from "axios";
import { MultiSelect } from "primereact/multiselect";

const LinkContactsPopup = ({ onSelectedJobsChange, errorJob, setSelectedScheduleContacts, errorContact, clearInterviewerError,jobLabel, companyId}) => {
    const [jobDetailsVisible, setJobDetailsVisible] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedJob, setSelectedJob] = useState(null); // Now single job
    const [lazyParams, setLazyParams] = useState({ page: 0, rows: 10 });
    const [jobs, setJobs] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);
    const [prioritycontact, setPrioritycontact] = useState([]);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [selectedContacts, setSelectedContacts] = useState([]);
    const [typeInterviewcontact, settypeInterviewcontact] = useState([]);
    const [selectedEmployees, setselectedEmployees] = useState(null);
    const [jobSearchText, setJobSearchText] = useState('');
    const [contactSearchText, setContactSearchText] = useState('');
    const [employeeFilter, setEmployeeFilter] = useState("");
    const filteredEmployees = prioritycontact.filter((emp) =>
        emp.name?.toLowerCase().includes(employeeFilter.toLowerCase())
    );




   const filteredJobs = (data) =>
    data.filter(job => {
        const q = jobSearchText.toLowerCase();
        return (
            job.title?.toLowerCase().includes(q) ||
            job.manager?.toLowerCase().includes(q) ||
            job.id?.toString().includes(jobSearchText)
        );
    });


    // const handleSave = () => {
    //     setJobDetailsVisible(false);
    //     setJobSearchText('');
    //     onSelectedJobsChange?.([selectedJob]); 
    // };
    const handleSave = () => {
  setJobDetailsVisible(false);
  setJobSearchText('');

  if (!selectedJob) {
    onSelectedJobsChange?.([]);   // 🔥 IMPORTANT
  } else {
    onSelectedJobsChange?.([selectedJob]);
  }
};


    const handleRefresh = () => {
        setSelectedJob(null);
        setSearchText('');
        onSelectedJobsChange?.([]);
    };

    const handleIconClick = () => {
        setJobSearchText('');
        setJobDetailsVisible(true);
    };
    const onPageChange = (event) => {
        setLazyParams({ page: event.page, rows: event.rows });
    };
    const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"));
    const intialcompanyId = userInfos.user_details.companies_data[0].company_id;
    // const [companyId, setCompanyId] = useState(intialcompanyId);
    const getallactivejobs = async () => {
        setLoading(true);
        try {
            const page = lazyParams?.page ?? 0;
            const rows = lazyParams?.rows ?? 10;
            // const response = await axios.get(`/api/v1/jobs/?page=${page + 1}&size=${rows}&status=Approved / Open&company_id=${companyId}`, {});
            const response = await axios.get(`/api/v1/create-job-order/?page=${page + 1}&size=${rows}&company_id=${companyId}`, {});
            if (response.status === 200) {
                const transformedData = response.data.results.map((cond) => ({
                    title: cond.job_title ?? '',
                    id: cond.job_id ?? '',
                    manager: cond.hiring_manager_name ?? '',
                    job_number: cond.job_number ?? '',
                    recruiters_names: cond.recruiters_names ?? []
                }));
                setJobs(transformedData);
                setTotalRecords(response.data.count || 0);
            } else {
                setJobs([]);
                setTotalRecords(0);
            }
        } catch (error) {
            console.error('Error fetching jobs:', error);
        }
        finally {
        setLoading(false); 
    }
    };
    useEffect(() => {
        if (companyId && companyId !== "All") {
            getallactivejobs();
            getallactivecontacts1()
        }
    }, [lazyParams.page, lazyParams.rows,companyId]);
    useEffect(() => {
  setSelectedJob(null);
  setSelectedContacts([]);
  setselectedEmployees(null);
  onSelectedJobsChange?.([]);
  setSelectedScheduleContacts?.([]);
}, [companyId]);


    const handleIconClickContact = () => {
        setDialogVisible(true);
    };
    const closeDialogContact = () => {
        setContactSearchText('');
        setDialogVisible(false);
    };

    const handleSaveContact = () => {
        const selectedIds = selectedContacts.map((contact) => contact.id);
        setPrioritycontact(selectedContacts.map((contact) => contact.name).join(', '));
        setSelectedScheduleContacts(selectedIds);
        setDialogVisible(false);
    };

    // const getallactivecontacts = async () => {
    //     try {
    //         const response = await axios.get(`/api/v1/get-all-hiring-managers/`, {});
    //         const transformedData = response.data.results.map((contact) => ({
    //             name: contact.first_name,
    //             id: contact.id || contact.user_id
    //         }));
    //         settypeInterviewcontact(transformedData);
    //     } catch (error) {
    //         console.error('Error fetching contacts:', error);
    //     }
    // };
const [loadingContacts,setLoadingContacts] = useState(true)
    const getallactivecontacts1 = async () => {
        setLoadingContacts(true);
        try {
            const response = await axios.get(
                `/api/v1/get-all-recruiters/?company_id=${companyId}`
            );
            const transformedData = response.data?.map(contact => ({
                name: `${contact.first_name} ${contact.middle_name} ${contact.last_name || ""}`,
                id: contact?.id,
            }));
            console.log("transformedData",response)
            setPrioritycontact(transformedData);
            settypeInterviewcontact(transformedData);
            // setTotalRecordsContacts(response.data.count || 0);
        } catch (error) {
            console.error("Error fetching contacts:", error);
        }
         finally {
            setLoadingContacts(false); 
        }
    };
    // useEffect(() => {
    //     getallactivecontacts1();
    // }, [companyId]);

   const filteredContacts = typeInterviewcontact?.filter(candidate =>
    candidate.name?.toLowerCase().includes(contactSearchText.toLowerCase()) ||
    candidate.id?.toString().includes(contactSearchText)
);


    return (
        <>
            <Col lg={6}>
                <div className="field">
                    <label htmlFor="job" className="block">{jobLabel}</label>
                    <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                        <InputText
                            id="job"
                            value={selectedJob ? `${selectedJob.title}, ${selectedJob.job_number}` : ''}
                            placeholder="Select Job"
                            className="w-full"
                            style={{ paddingRight: '2rem', cursor: "pointer" }}
                            // readOnly
                            onClick={handleIconClick}
                        />
                        <i
                            className="pi pi-chevron-down"
                            onClick={handleIconClick}
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                cursor: 'pointer'
                            }}
                        ></i>
                    </div>
                    <Dialog
                        header="Link Jobs"
                        visible={jobDetailsVisible}
                        onHide={() => setJobDetailsVisible(false)}
                        style={{ width: '40vw' }}
                        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                        className="cand-details"
                    >
                        <Row>
                            <Col lg={12}>
                                <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                   <InputText
                                    placeholder="Search Jobs"
                                    value={jobSearchText}
                                    onChange={(e) => setJobSearchText(e.target.value)}
                                    style={{ paddingRight: '2rem' }}
                                />

                                    <i
                                        className="pi pi-search"
                                        style={{
                                            position: 'absolute',
                                            right: '10px',
                                            top: '49%',
                                            transform: 'translateY(-50%)',
                                        }}
                                    ></i>
                                </div>
                            </Col>
                        </Row>
                        <DataTable
                            value={filteredJobs(jobs)}
                            selection={selectedJob}
                            onSelectionChange={(e) => setSelectedJob(e.value)}
                            dataKey="id"
                            size="small"
                            scrollable
                            scrollHeight="320px"
                            id="AllEmployees_TableView"
                            lazy paginator first={lazyParams.page * lazyParams.rows}
                            rows={lazyParams.rows} totalRecords={totalRecords} onPage={onPageChange} loading={loading}
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                            currentPageReportTemplate="{first} to {last} of {totalRecords}"
                            rowsPerPageOptions={[10, 20, 50, totalRecords]}
                        >
                            <Column selectionMode="single" style={{ width: '3em' }} />
                            <Column field="job_number" header="Job ID" />
                            <Column field="title" header="Job Title" />
                           <Column
                                field="manager"
                                header="Contact"
                                body={(rowData) => {
                                    const names = rowData.recruiters_names;

                                    if (!names || names.length === 0) return "--";

                                    const text = names.join(", ");

                                    return (
                                    <span
                                        title={text}
                                        style={{
                                        maxWidth: '180px',      
                                        display: 'inline-block',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        verticalAlign: 'middle',
                                        cursor: 'pointer'
                                        }}
                                    >
                                        {text}
                                    </span>
                                    );
                                }}
                                style={{ width: '180px' }}  
                                />

                        </DataTable>
                        <div className="d-flex mt-3 justify-content-center">
                            <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSave}>Save</button>
                            <button type="button" className="btn btn-primary btn-main" onClick={handleRefresh}>Refresh</button>
                        </div>
                    </Dialog>
                    {errorJob && <p className="p-error">{errorJob}</p>}
                </div>
            </Col>
            <Col xl={6}>
                <div className="p-field flex flex-column">
                    <label htmlFor="contact" className="block">
                        Interviewer <span className="text-danger">*</span>
                    </label>
                    <div className="d-flex align-items-center" style={{ position: 'relative' }}>
                        <MultiSelect
                            id="company"
                            value={selectedEmployees}
                            options={filteredEmployees}
                            onChange={(e) => {
                                setselectedEmployees(e.value);
                                const selectedIds = e.value.map((item) => item.id);
                                setSelectedScheduleContacts(selectedIds);
                                 if (e.value.length) {
                                clearInterviewerError?.();
                                }
                                setEmployeeFilter("");
                            }}
                            placeholder="Select Interviewer"
                            optionLabel="name"
                            filter
                            // filterBy="name"
                            filterTemplate={() => (
                                <input
                                    type="text"
                                    className="p-inputtext p-component w-100"
                                    placeholder="Search..."
                                    value={employeeFilter}
                                    onChange={(e) => setEmployeeFilter(e.target.value)}
                                />
                            )}
                            display="comma"
                            className="w-full activejobdrop border"
                            loading={loadingContacts}
                             tooltip={
                                selectedEmployees?.length
                                ? selectedEmployees.map(emp => emp.name).join(", ")
                                : "Select Interviewer"
                            }
                            tooltipOptions={{ position: "top" }}
                        />
                    </div>
                    {errorContact && <p className="p-error">{errorContact}</p>}
                    <Dialog
                        header="Select Contacts"
                        visible={dialogVisible}
                        onHide={closeDialogContact}
                        style={{ width: '40vw' }}
                        breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                        className="cand-details"
                    >
                        <Col lg={12}>
                            <div className="p-inputgroup mb-3" style={{ position: 'relative' }}>
                                <InputText
                                    placeholder="Search Contacts"
                                    value={contactSearchText}
                                    onChange={(e) => setContactSearchText(e.target.value)}
                                    style={{ paddingRight: '2rem' }} // Space for the icon
                                />
                                <i
                                    className="pi pi-search"
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '49%',
                                        transform: 'translateY(-50%)',
                                    }}
                                ></i>
                            </div>
                        </Col>
                        <DataTable
                            value={filteredContacts}
                            paginator
                            rows={5}
                            selection={selectedContacts}
                            onSelectionChange={(e) => {setSelectedContacts(e.value);setContactSearchText('');}}
                            dataKey="id"
                            rowsPerPageOptions={[5, 10, 25]}
                            size="small"
                        >
                            <Column selectionMode="multiple" headerStyle={{ width: '3em' }} />
                            <Column field="name" header="Contact Name" />
                        </DataTable>
                        <div className="d-flex mt-3">
                            <button type="button" className="btn btn-primary me-2 btn-main" onClick={handleSaveContact}>Save</button>
                            <button type="button" className="btn btn-primary btn-main" onClick={closeDialogContact}>Cancel</button>
                        </div>
                    </Dialog>
                </div>
            </Col>
        </>
    );
};

export default LinkContactsPopup;
